import { mapGetters } from 'vuex';
import mvtWelcome from '@/common/components/mvtwelcome/mvt-welcome.vue';
import agentBrokerage from '@/agent/components/agentbrokerage/agent-brokerage.vue';
import agentWorkflow from '@/agent/components/agentworkflow/agent-workflow.vue';
import agentTourlink from '@/agent/components/agenttourlink/agent-tourlink.vue';
import agentConnect from '@/agent/components/agentconnect/agent-connect.vue';
import agentTips from '@/agent/components/agenttips/agent-tips.vue';
import agentBanner from '@/agent/components/agentbanner/agent-banner.vue';
import brokerageBanner from '@/agent/components/brokeragebanner/brokerage-banner.vue';
import agentBar from '@/agent/components/agentbar/agent-bar.vue';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import mvtSnapshot from '@/common/components/mvtsnapshot/mvt-snapshot.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';

export default {
    name: 'pageAgentHome',
    inject: ['$eventBus'],
    components: {
        mvtDialogCenter,
        mvtNearby,
        mvtSnapshot,
        agentBar,
        mvtWelcome,
        agentBrokerage,
        agentTips,
        agentBanner,
        agentWorkflow,
        agentTourlink,
        agentConnect,
        brokerageBanner,
        mvtHotleadForm,
        mvtHeader,
        mvtFooter,
        mvtLazyload,
    },
    data() {
        return {
            states: [],
            hasNewListings: true,
            hotleadType: 'AgentCitySell',
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('agents', ['agentCity']),
        geo() {
            return this.agentCity.geo;
        },
        snapshotData() {
            let data = this.agentCity.snapshot && this.agentCity.snapshot.one_month_ago;
            if (
                data &&
                !(
                    data.singleTypeMedianListPrice > 0 ||
                    data.singleTypeMedianHouseSize > 0 ||
                    data.singleTypeMedianDom > 0 ||
                    data.singleTypeMedianPricePerSqftHouse > 0 ||
                    data.condoTypeMedianListPrice > 0 ||
                    data.condoTypeMedianHouseSize > 0 ||
                    data.condoTypeMedianDom > 0 ||
                    data.condoTypeMedianPricePerSqftHouse > 0 ||
                    data.allTypeMedianListPrice > 0 ||
                    data.allTypeMedianHouseSize > 0 ||
                    data.allTypeMedianDom > 0 ||
                    data.allTypeMedianPricePerSqftHouse > 0
                )
            ) {
                data = null;
            }
            return data || null;
        },
        agentBarOptions() {
            let opts = {};
            // if(this.snapshotData){
            //     opts.isSnapshotDataAvailable = true;
            // }
            return opts;
        },
    },
    methods: {
        openHotlead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadSup: 'GET STARTED',
                    hotleadTitle: 'Connect with a top-rated local agent' + (this.glb.geo && this.glb.geo.city ? ' in ' + this.glb.geo.city : ''),
                    hotleadType: this.hotleadType,
                    buttonText: 'Connect with a Top Agent',
                    showGeo: true,
                },
            });
        },
        completed(newListings) {
            this.hasNewListings = newListings && newListings.length ? true : false;
            this.$refs.lazyload.ready();
        },
    },
};
